<template>
    <button
        :key="score"
        type="button"
        :class="pressedClass"
        @click="onPress"
    >
        <font-awesome-icon icon="star" class="pulse-star" />
        <font-awesome-icon icon="star" class="twirling-star" />
        <template v-if="ratedScore >= score">
            <font-awesome-icon icon="star" class="star text-green-500" />
        </template>
        <template v-else>
            <font-awesome-icon
                :icon="['fal', 'star']"
                class="star"
                :class="[hoverScore >= score ? 'text-green-500' : 'text-gray-400']"
            />
        </template>
    </button>
</template>

<script>
    export default {
        props: {
            score: {
                type: Number,
                required: true,
            },
            ratedScore: {
                type: Number,
                default: null,
            },
            hoverScore: {
                type: Number,
                default: null,
            },
        },

        data() {
            return {
                pressedClass: null,
            };
        },

        methods: {
            onPress() {
                this.$emit('pressed');
                this.pressedClass = 'rate-star-pressed';
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.pressedClass = null;
                }, 2000);
            },
        },
    };
</script>
